import React, { Component } from "react";

export default class InfoAlert extends Component {
  render() {
    return (
      <div class="alert alert-info alert-dismissible">
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-hidden="true"
        >
          &times;
        </button>
        <h4>
          <i class="fas fa-lightbulb"></i> {this.props.message}
        </h4>
      </div>
      // </div></div></section></div>
    );
  }
}
